<script setup lang="ts">
import type { Sticker } from "~/types";

defineProps({
  stickers: {
    type: Object as PropType<Sticker[]>,
    required: true,
  },
});

const emit = defineEmits<{
  (e: "send-sticker", sticker: Sticker): void;
}>();

function sendSticker(sticker: Sticker) {
  emit("send-sticker", sticker);
}
</script>

<template>
  <div class="picker-container">
    <div class="grid-container">
      <div v-for="(sticker, index) in stickers" :key="`sticker_${index}`">
        <img
          class="sticker"
          :src="`${sticker.value}`"
          alt="sticker alt"
          @click="sendSticker(sticker)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.picker-container {
  height: 420px;
  width: 332px;
  overflow-y: scroll;
}
.sticker {
  max-height: 100px;
  max-width: 100px;
  cursor: pointer;
}
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 10px;
  text-align: center;
}
</style>
